// extracted by mini-css-extract-plugin
export default {"eventsTotalContainer":"SearchResultsPage_eventsTotalContainer__40jl7","resultsMessage":"SearchResultsPage_resultsMessage__3zogv","searchQuery":"SearchResultsPage_searchQuery__FEvSG"};